import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The step template's former address (NAV-84). The page is called "Evaluation
 * Steps" and lives at `/bu-admin/evaluation-steps`; "workflows" was the source
 * application's word for it and named nothing on the screen.
 */
export const Route = createFileRoute("/bu-admin/workflows")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/bu-admin/evaluation-steps", search, replace: true });
  },
});
